
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started/first-automation",
      function () {
        return require("private-next-pages/getting-started/first-automation.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-started/first-automation"])
      });
    }
  